import { ApiError } from "../api.js";

/**
 * Build the on-screen auth failure message. The server's own words matter:
 * "Access restricted to the event host or co-hosts" and "No Hoogah user found
 * for x@y.com" are different problems that a bare status code cannot separate.
 */
export function authErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    return `Authentication failed (${err.status}) — ${err.message}`;
  }
  if (err instanceof Error) {
    return `Authentication failed — ${err.name}: ${err.message}`;
  }
  return "Authentication failed";
}
